import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Table,
  Form,
  FormGroup,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";

import {
  PanelHeader,
  Stats,
  Statistics,
  CardCategory,
  Progress,
  Button
} from "components";

import {
  dashboardPanelChart,
  dashboardActiveUsersChart,
  dashboardSummerChart,
  dashboardActiveCountriesCard
} from "variables/charts.jsx";

import jacket from "assets/img/saint-laurent.jpg";
import shirt from "assets/img/balmain.jpg";
import swim from "assets/img/prada.jpg";

import { table_data } from "variables/general.jsx";
import moment from "moment";

///  <NUEVO PARA NOTIFICAR SIM>
import SweetAlert from "react-bootstrap-sweetalert";
///  </NUEVO PARA NOTIFICAR SIM>
import Iframe from "react-iframe";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLastfmSquare } from "@fortawesome/free-brands-svg-icons";

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

const CONFIRMAR_SIM = "SIM";
const ENTER_KEY = 13;
var checkICC = (function(a) {
  return function(c) {
    for (var l = c.length, b = 1, s = 0, v; l; )
      (v = parseInt(c.charAt(--l), 10)), (s += (b ^= 1) ? a[v] : v);
    return s && 0 === s % 10;
  };
})([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);

class Tools extends React.Component {
  constructor(props) {
    super(props);
    /* //console.log("########## PROPS ###########");
    //console.log(props); */
    this.state = {
      servicesSize: 3,
      ordersChartReady: false,
      ordersToDisplayInChart: 6,
      fieldStates: [],
      ICC: "",
      confirmICC: "", //ICC del envío
      fieldsToValidateSIMDelivery: ["ICC"],
      confirmingDelivery: "",
      currentApn: "",
      currentCompartir: "",
      searchONTsQuery: ""
    };

    this.createMobileCards = this.createMobileCards.bind(this);
    this.addSize = this.addSize.bind(this);
    this.subSize = this.subSize.bind(this);
    this.loadOrdersChart = this.loadOrdersChart.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.createPopUp = this.createPopUp.bind(this);
    this.showPopUp = this.showPopUp.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateSIMDelivery = this.validateSIMDelivery.bind(this);
    this.createConfirmSIMDeliveryPopUp = this.createConfirmSIMDeliveryPopUp.bind(this);
    this.showPopUpConfirmation = this.showPopUpConfirmation.bind(this);
    this.hidePopUpConfirmation = this.hidePopUpConfirmation.bind(this);
    this.createCurrentTools = this.createCurrentTools.bind(this);
    this.isToolSelected = this.isToolSelected.bind(this);
    this.unsubscribeMobile = this.unsubscribeMobile.bind(this);
    this.createMobileUnsubscribeHistory = this.createMobileUnsubscribeHistory.bind(this);

    this.getONTsFound = this.getONTsFound.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.searchONTs = this.searchONTs.bind(this);
    this.validateICC = this.validateICC.bind(this);
    this.freeSIM = this.freeSIM.bind(this);
  }
  componentDidMount() {
    this.props.userData.unsubscribe_mobile_history();
    // console.log("this.props", this.props);
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  validateICC(icc) {
    if (!icc) return false;
    return checkICC(icc) && (icc.length === 19 || icc.length === 20);
  }
  validateField(field, value) {
    let fieldStates = this.state.fieldStates;
    switch (field) {
      case "phoneNumber":
        if (this.validatePhoneNumber(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "ICC":
        if (this.validateICC(value)) {
          fieldStates[field] = "has-success";
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      case "iban":
        if (this.validateIBAN(value)) {
          fieldStates[field] = "has-success";
          if (this.isNewIBAN(value)) {
            this.props.setCustomerIBAN(this.state.customer.id, value);
            this.setState({ latestValidatedIBAN: value.replace(/ /g, "") });
          }
        } else {
          fieldStates[field] = "has-danger";
        }
        break;
      default:
    }
    this.setState({ fieldStates: fieldStates });
  }
  showPopUp(tipo) {
    // console.log("######### OPCIONES ###########");
    // console.log(this.props.mainState);
    this.setState({
      popUpToShow: tipo,
      showPopUp: true,
      confirmICC: "",
      ICC: "",
      confirmingDelivery: "",
      fieldStates: []
    });
  }
  validateSIMDelivery() {
    let validation = true;
    this.state.fieldsToValidateSIMDelivery.map((item,key) => 
    {
      this.validateField(item, this.state[item]);
      if (this.state.fieldStates[item] === "has-danger") validation = false;
      if (!this.state[item] || this.state[item] === "") {
        validation = false;
      }
    });
    return validation;
  }
  deliverySIMConfirmation() {
    if (!this.validateSIMDelivery()) {
      return;
    }
    this.props.confirmSIMDelivery(this.state.confirmingDelivery);
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block"/*, marginTop: "-250px" */}}
          title="¡Recepción confirmada!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          Hemos lanzado tu portabilidad, en 36-48h hábiles (sin contar festivos ni fines de semana) estará lista.
        </SweetAlert>
      )
    });
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case CONFIRMAR_SIM:
        this.deliverySIMConfirmation();
        break;
      default:;
    }
  }
  createPopUp() {
    // console.log("############# CREATING POPUP #############");
    // console.log(this.state);
    // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case CONFIRMAR_SIM:
        return this.createConfirmSIMDeliveryPopUp();
      default:
        //console.log("################## ERROR CREATE POPUP ################");
        //console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  createConfirmSIMDeliveryPopUp() {
    return (
      <SweetAlert
        style={{ display: "block"/*, marginTop: "-250px"*/ }}
        title="Confirmar SIM"
        onConfirm={() => this.showPopUpConfirmation(CONFIRMAR_SIM)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Confirmar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row className="text-center">
            <div style={{margin: "0 2em 1em 2em", textAlign: "justify"}}>
              <span>Para confirmar la recepción de la SIM, escribe los 4 últimos números de la ICC de la SIM (Los 4 últimos números del código de barras)</span>
            </div> 
            <Col xs={12} md={9}>
              <FormGroup className={this.state.fieldStates["ICC"]}>
                <Input
                  type="number"
                  value={this.state.ICC}
                  onChange={event => {
                    this.setState({ ICC: event.target.value.replace(/\s+/g, '') });
                    this.validateField("ICC", event.target.value.replace(/\s+/g, ''));
                  }}
              />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  loadOrdersChart() {
    let ordersChartDates = [];
    let ordersChartTotals = [];
    let partialOrders = [];
    if(this.props.mainState.orders.length > this.state.ordersToDisplayInChart) {
      partialOrders = this.props.mainState.orders.slice(0,this.state.ordersToDisplayInChart).reverse();
    }else{
      partialOrders = this.props.mainState.orders.slice(0).reverse();
    }

    partialOrders.map((currentOrder, key) =>{
      ordersChartDates.push(
        moment(currentOrder.fecha, "YYYY/MM/DD").format(
          "MMM YYYY"
        ) /* 
        new Intl.DateTimeFormat("es-ES", {
          year: "numeric",
          month: "short"
        }) 
          .format(Date.parse(currentOrder.fecha))
          .replace(".", "")*/
      );
      ordersChartTotals.push(
        parseFloat(
          currentOrder.total
            .replace(",", ".")
            .substring(0, currentOrder.total.length - 2)
        )
      );
    });

    let ordersChart = {
      data: canvas => {
        const ctx = canvas.getContext("2d");
        var chartColor = "#FFFFFF";
        var gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
        gradientStroke.addColorStop(0, "#80b6f4");
        gradientStroke.addColorStop(1, chartColor);
        var gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
        gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
        gradientFill.addColorStop(1, "rgba(255, 255, 255, 0.14)");
    
        return {
          labels: ordersChartDates,
          datasets: [
            {
              label: "Total",
              borderColor: chartColor,
              pointBorderColor: chartColor,
              pointBackgroundColor: "#2c2c2c",
              pointHoverBackgroundColor: "#2c2c2c",
              pointHoverBorderColor: chartColor,
              pointBorderWidth: 1,
              pointHoverRadius: 7,
              pointHoverBorderWidth: 2,
              pointRadius: 5,
              fill: true,
              backgroundColor: gradientFill,
              borderWidth: 2,
              data: ordersChartTotals
            }
          ]
        };
      },
      options: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: "#fff",
          titleFontColor: "#333",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest"
        },
        legend: {
          position: "bottom",
          fillStyle: "#FFF",
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,

                // Return an empty string to draw the tick line but hide the tick label
                // Return `null` or `undefined` to hide the tick line entirely
                userCallback: function(value, index, values) {
                    // Convert the number to a string and splite the string every 3 charaters from the end
                    value = value.toString();
                    value = value.split(/(?=(?:...)*$)/);
        
                    // Convert the array to a string and format the output
                    value = value.join('.');
                    return value + ' €';
                }
              },
              gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)"
              },
              ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold"
              }
            }
          ]
        }
      }
    };

    this.setState({
      ordersChartReady: true,
      ordersChart: ordersChart
    });
  }
  addSize() {
    this.setState({
      servicesSize: this.state.servicesSize + 1
    });
  }
  subSize() {
    this.setState({
      servicesSize: this.state.servicesSize - 1
    });
  }
  createTableData() {
    var tableRows = [];
    for (var i = 0; i < table_data.length; i++) {
      tableRows.push(
        <tr key={i}>
          <td>
            <div className="flag">
              <img src={table_data[i].flag} alt="us_flag" />
            </div>
          </td>
          <td>{table_data[i].country}</td>
          <td className="text-right">{table_data[i].count}</td>
          <td className="text-right">{table_data[i].percentage}</td>
        </tr>
      );
    }
    return tableRows;
  }
  createMobileCards() {
    let mobileContent = null;
    if(this.props.mainState.hasMobile && this.props.mainState.mobilesLoaded){      
      mobileContent = this.props.mainState.mobiles.map((currentMobile, key) =>{
        return (
          <Col key={currentMobile.mobile} xs={12} md={this.state.servicesSize}>
            <Card className="card-stats card-raised">
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    <Link to={this.props.mainState.mobilesCDRLoaded ? "/movil/" + currentMobile.mobile : "/movil"}>
                      <Statistics
                        showIcon
                        iconState="primary"
                        icon="tech_mobile"
                        title={currentMobile.mobile.substring(0,3) + " " + currentMobile.mobile.substring(3,6) + " " + currentMobile.mobile.substring(6,9)}
                        subtitle={currentMobile.plan.replace(" (Móvil)", "")}
                      />
                    </Link>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        );
      });
    }else if(this.props.mainState.mobilesLoaded){
      mobileContent = 
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="danger"
                    icon="tech_mobile"
                    title="Móviles"
                    subtitle="¡Trae tus móviles!"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>;
    }else{
      mobileContent = 
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Móviles"
                    subtitle="Cargando..."
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>;
    }
    return mobileContent;
  }
  createToolsCards() {
    let toolsCards = [];
    let currentParams = this.props.match.params;
    let currentTool = null;
    let availableToolsCards = [];
    let _isToolSelected = this.isToolSelected();
    if (_isToolSelected) currentTool = currentParams.tool;
    let bajaLemonCard = 
      <Col key={"bajaLemonCard"} xs={12} md={_isToolSelected ? 12 - this.state.servicesSize : this.state.servicesSize}>
        <Link to="/herramientas/baja-lemon">
          <Card className="card-stats card-raised" color={currentTool === "baja-lemon" ? "white" : "white"}>
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="danger"
                    icon="design_scissors"
                    title="Baja Lemon"
                    subtitle="Dar de baja un móvil de Lemon"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Link>
      </Col>;
    if (!this.props.mainState.isTechnician()) {
      availableToolsCards["baja-lemon"] = bajaLemonCard;
    }
    let liberarSIMLemonCard = 
      <Col key={"liberarSIMLemonCard"} xs={12} md={_isToolSelected ? 12 - this.state.servicesSize : this.state.servicesSize}>
        <Link to="/herramientas/liberar-SIM">
          <Card className="card-stats card-raised" color={currentTool === "liberar-SIM" ? "white" : "white"}>
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="warning"
                    icon="ui-1_lock-circle-open"
                    title="Liberar SIM"
                    subtitle="Libera una SIM de Lemon"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Link>
      </Col>;
    if (!this.props.mainState.isTechnician()) {
      availableToolsCards["liberar-SIM"] = liberarSIMLemonCard;
    }
    
    let ftthSignalCard = 
      <Col key={"ftthSignalCard"} xs={12} md={_isToolSelected ? 12 - this.state.servicesSize : this.state.servicesSize}>
        <Link to="/herramientas/ftth-signal"> 
          <Card className="card-stats card-raised" color={currentTool === "ftth-signal" ? "white" : "white"}>
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="warning"
                    icon="design-2_ruler-pencil"
                    title="Medir señal"
                    subtitle="Mide la señal de la fibra óptica"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Link>
      </Col>;

    //Si es un técnico ponemos esta la primera
    if (this.props.mainState.isTechnician()) {
      availableToolsCards["ftth-signal"] = ftthSignalCard;
    }
    let examineAntennaConfiguration = 
      <Col key={"examineAntennaConfigurationCard"} xs={12} md={_isToolSelected ? 12 - this.state.servicesSize : this.state.servicesSize}>
        <Link to="/herramientas/antenna-config"> 
          <Card className="card-stats card-raised" color={currentTool === "antenna-config" ? "white" : "white"}>
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="info"
                    icon="ui-1_settings-gear-63"
                    title="Config Antena"
                    subtitle="Analiza la configuración de la antena"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Link>
      </Col>;
    availableToolsCards["antenna-config"] = examineAntennaConfiguration;

    let apnCard = 
      <Col key={"apnCard"} xs={12} md={_isToolSelected ? 12 - this.state.servicesSize : this.state.servicesSize}>
        <Link to="/herramientas/apn">
          <Card className="card-stats card-raised" color={currentTool === "apn" ? "white" : "white"}>
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="primary"
                    icon="location_world"
                    title="Configurar APN"
                    subtitle="Configura Internet en tu móvil"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Link>
      </Col>;
    availableToolsCards["apn"] = apnCard;
    
    let compartirDatos = 
      <Col key={"compartirDatos"} xs={12} md={_isToolSelected ? 12 - this.state.servicesSize : this.state.servicesSize}>
        <Link to="/herramientas/compartir"> 
          <Card className="card-stats card-raised" color={currentTool === "compartir" ? "white" : "white"}>
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="info"
                    icon="ui-1_lock-circle-open"
                    title="Compartir datos"
                    subtitle="¿Quieres compartir tus datos?"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Link>
      </Col>;
    availableToolsCards["compartir"] = compartirDatos;
    
    let testVelocidadCard = 
      <Col key={"testVelocidadCard"} xs={12} md={_isToolSelected ? 12 - this.state.servicesSize : this.state.servicesSize}>
        <Link to="/herramientas/test-velocidad"> 
          <Card className="card-stats card-raised" color={currentTool === "test-velocidad" ? "white" : "white"}>
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="danger"
                    icon="objects_spaceship"
                    title="Test de velocidad"
                    subtitle="¿Es rápida tu conexión?"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Link>
      </Col>;
    availableToolsCards["test-velocidad"] = testVelocidadCard;

    if (!("ftth-signal" in availableToolsCards)) availableToolsCards["ftth-signal"] = ftthSignalCard;

    if (!this.isToolSelected()) {
      Object.keys(availableToolsCards).map(currentKey => {
        toolsCards.push(availableToolsCards[currentKey]);
      });
    } else {
      let volverCard = 
        <Col key={"volverCard"} xs={12} md={this.state.servicesSize}>
          <Link to="/herramientas"> 
            <Card className="card-stats card-raised" color={"white"}>
              <CardBody>
                <Row>
                  <Col xs={12} md={12}>
                    <Statistics
                      showIcon
                      iconState="default"
                      icon="arrows-1_minimal-left"
                      title="Volver"
                      subtitle="Ver todas las herramientas"
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Link>
        </Col>;
      toolsCards.push(volverCard);
      toolsCards.push(availableToolsCards[currentTool]);
    }
    // console.log("toolsCards", toolsCards);

    return toolsCards;
  }
  checkMobile(mobile) {
    let mobileInt = mobile ? parseInt(mobile) : 0;
    let result = true;
    if (!mobile || mobile.length !== 9) result = false;
    if (!(mobileInt > 600000000 && mobileInt < 900000000)) result = false;
    return result;
  }
  unsubscribeMobile() {
    let mobile = this.state.mobile;
    if (this.checkMobile(mobile)) {
      this.props.userData.unsubscribe_mobile(mobile);
    } else {
      let options = {
        place: "tr",
        message: "El número de móvil es incorrecto",
        type: "danger",
        icon: "now-ui-icons ui-2_settings-90",
        autoDismiss: 0
      };
      this.props.userData.showNotification(options);
    }
  }
  createMobileUnsubscribeHistory() {
    let result = null;
    // console.log("historyTest", this.props.mainState.unsubscribeHistory);

    if (this.props.mainState.unsubscribeHistory && this.props.mainState.unsubscribeHistory.length > 0) {
      result = this.props.mainState.unsubscribeHistory.map(history => {
        return null
      }); 
      result = (
        <Card>
          <CardBody>
            <Table responsive>
              <thead>
                <tr className="">
                  <th className="text-center">Fecha</th>
                  <th className="text-center">Estado</th>
                  <th>Descripción</th>
                </tr>
              </thead>
              <tbody>
                {this.props.mainState.unsubscribeHistory.map(history => {
                  let historyStatusStyle = {
                    padding: "10px 15px",
                    borderRadius: "3px",
                    background: "rgba(70,185,138, 0.8)",
                    color: "#FFF",
                    fontSize: "10px"
                  };
                  let historyDateStyle = {
                    padding: "10px 15px",
                    borderRadius: "3px",
                    background: "#EEE",
                    color: "#111",
                    fontSize: "10px"
                  };
                  if (history.error)
                    historyStatusStyle.background = "rgba(192,57,43, 0.8)";
                  try {
                    // console.log("###### Trámite ######");
                    // console.log(procedure);
                    return (
                      <tr key={history.id}>
                        <td className="text-center"><span style={historyDateStyle}>{history.date}</span></td>
                        <td className="text-center"><span style={historyStatusStyle}>{history.error? "Error" : "OK"}</span></td>
                        <td>{history.title}</td>
                      </tr>
                    );
                  } catch (error) {
                    console.error(error);
                    return null;
                    // expected output: ReferenceError: nonExistentFunction is not defined
                    // Note - error messages will vary depending on browser
                  }
                })}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      );
    }

    return result;
  }
  createOpticalSignal(signal) {
    if (!signal) return null;
    let color = "#ee5253";
    if (signal >= -21) color = "#46B98A";
    if (signal < -21 && signal >= -25) color = "#ff9f43";

    return <span style={{ color: color }}>{signal}</span>;
  }
  getONTsFound() {
    console.log("getONTsFound -> this.props.mainState.foundONTs: ", this.props.mainState.foundONTs);
    if (this.props.mainState.searchONTsQuery) {
      if (this.props.mainState.isSearchingONTs) {
        return (
          <div className="text-center">
            <span>
              <i className="now-ui-icons arrows-1_refresh-69 spin" />{" "}
              Buscando ONTs con <b>{this.props.mainState.searchONTsQuery}</b>...
            </span>
          </div>
        );
      }
      if (this.props.mainState.foundONTs) {        
        if (this.props.mainState.searchONTsQuery in this.props.mainState.foundONTs) {
          let onts = this.props.mainState.foundONTs[this.props.mainState.searchONTsQuery];
          if (!onts || onts.length === 0) 
            return (
              <div className="text-center">
                <span>
                  No se encontraron coincidencias para{" "}
                  <b>{this.props.mainState.searchONTsQuery}</b>...
                </span>
              </div>
            );
          let onts_ready = Object.keys(onts).map(pso_id => {
            let current_pso_onts = onts[pso_id].found_onts.onts;
            let pso = onts[pso_id].pso;
            return current_pso_onts.map(ont => {
              let ont_status = ont.online ? "online" : "offline";
              return (
                <Col xs={12} key={ont.sn}>
                  <Card className="ont-card">
                    <CardBody>
                      <Row className="ont">
                        <div className={"ont-status " + ont_status}></div>
                        <Col xs={12} sm={3}>
                          <span><span className="category">PSO: </span>{pso.name}</span><br />
                          <span><span className="category">SN: </span>{ont.sn}</span><br />
                          <span><span className="category">Model: </span>{ont.model}</span>
                        </Col>
                        <Col xs={12} sm={3}>
                          <span><span className="category">Nombre: </span>{ont.name}</span><br />
                          <span><span className="category">Descripción: </span>{ont.description}</span>
                        </Col>
                        <Col xs={12} sm={3}>
                          <span><span className="category">Estado: </span>{ont.online ? "Online" : "Offline"}</span><br />
                          <span><span className="category">RX: </span><b>{this.createOpticalSignal(ont.signal.rx)}</b></span><br />
                          <span><span className="category">TX: </span><b>{this.createOpticalSignal(ont.signal.tx)}</b></span>
                        </Col>
                        <Col xs={12} sm={3}>
                          <span><b>WiFi</b></span><br />
                          <span><span className="category">Red: </span>{ont.wifi.ssid}</span><br />
                          <span><span className="category">Pass: </span>{ont.wifi.pass}</span>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              );
            });
          });
          return <Row className="ont-list">{onts_ready}</Row>;
        } else {
          return (
            <div className="text-center">
              <span>
                <i className="now-ui-icons arrows-1_refresh-69 spin" />{" "}
                Buscando ONTs con <b>{this.props.mainState.searchONTsQuery}</b>...
              </span>
            </div>
          );
        }
      }
    } else {
      return (
        <div className="text-center">
          <span>
            Realiza una búsqueda, aquí aparecerán los resultados.
          </span>
        </div>
      );
    }
  }
  handleChange(value) {
    // console.log("handleChange", value);
    // clearTimeout(this.timer);

    let state = this.state;
    state.searchONTsQuery = value.target.value;

    this.setState(state);

    // this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
  }
  handleKeyDown(e) {
    // console.log("handleKeyDown", e);
    if (e.keyCode === ENTER_KEY) {
        this.searchONTs();
    }
  }
  searchONTs() {
    console.log("searchONT", this.state.searchONTsQuery);
    this.props.userData.searchONTs(this.state.searchONTsQuery);
  }
  freeSIM() {
    console.log("freeSIM", this.state.iccQuery);
    this.props.userData.freeSIM(this.state.iccQuery);
  }
  createCurrentTools() {
    let currentParams = this.props.match.params;
    if (!currentParams) return;
    let currentTool = null;
    let iframeToShow = null;

    switch (currentParams.tool) {
      case "apn":
        if (this.state.currentApn)
          iframeToShow = 
            <Card>
              <CardBody>
                <Row>
                  <Iframe
                    width="100%"
                    height="900px"
                    frameBorder="0"
                    src={"https://nadunet.es/apn/" + this.state.currentApn + "/api"}
                  />
                </Row>
              </CardBody>
            </Card>;
        currentTool = 
          <div>
            <Card className="card-plain card-subcategories">
              <CardBody>
                <Nav
                  pills
                  className="nav-pills-primary nav-pills-icons justify-content-center"
                >
                  <NavItem>
                    <NavLink
                      className={
                        this.state.currentApn === "samsung" ? "active" : ""
                      }
                      onClick={() =>
                        this.setState({ currentApn: "samsung" })
                      }
                    >
                      <div>
                        <FontAwesomeIcon icon={['fab', 'stripe-s']} size="3x"/>
                        {/* <FontAwesomeIcon icon={['fab', 'apple']}  size="lg"/> */}
                      </div>
                      Samsung
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={
                        this.state.currentApn === "xiaomi" ? "active" : ""
                      }
                      onClick={() =>
                        this.setState({ currentApn: "xiaomi" })
                      }
                    >
                      <div>
                        <FontAwesomeIcon icon="times" size="3x"/>
                        {/* <FontAwesomeIcon icon={['fab', 'apple']}  size="lg"/> */}
                      </div>
                      Xiaomi
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={
                        this.state.currentApn === "huawei" ? "active" : ""
                      }
                      onClick={() =>
                        this.setState({ currentApn: "huawei" })
                      }
                    >
                      <div>
                        <FontAwesomeIcon icon="heading" size="3x"/>
                      {/* <FontAwesomeIcon icon={['fab', 'apple']}  size="lg"/> */}
                      </div>
                      Huawei
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={
                        this.state.currentApn === "apple" ? "active" : ""
                      }
                      onClick={() =>
                        this.setState({ currentApn: "apple" })
                      }
                    >
                      <div>
                        <FontAwesomeIcon icon={['fab', 'apple']}  size="3x"/>
                      </div>
                      Apple
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={
                        this.state.currentApn === "otros" ? "active" : ""
                      }
                      onClick={() =>
                        this.setState({ currentApn: "otros" })
                      }
                    >
                      <div>
                        <FontAwesomeIcon icon="mobile-alt" size="3x" />
                      </div>
                      Otros Android
                    </NavLink>
                  </NavItem>
                </Nav>
                {/* <TabContent
                  className="tab-space tab-subcategories"
                  activeTab={this.state.currentApn}
                >
                  <TabPane tabId={this.state.currentApn}>
                    Collaboratively administrate empowered markets via
                    plug-and-play networks. Dynamically procrastinate B2C
                    users after installed base benefits.
                    <br />
                    <br />
                    Dramatically visualize customer directed convergence
                    without revolutionary ROI.
                  </TabPane>
                </TabContent> */}
              </CardBody>
            </Card>
            {iframeToShow}
          </div>;
        break;
      case "test-velocidad":
        currentTool = 
          <Card color="info">
            <CardHeader>
              <h5 className="title" style={{color:"white"}}>Test de velocidad</h5>
            </CardHeader>
            <CardBody>
              <Row>
                <Iframe
                  width="100%"
                  height="650px"
                  frameBorder="0"
                  src="https://nadunet.speedtestcustom.com"
                  loading="eager"
                />
              </Row>
            </CardBody>
          </Card>;
        break;
      case "compartir":
        if (this.state.currentCompartir)
          iframeToShow = 
            <Card>
              <CardBody>
                <Row>
                  <Iframe
                    width="100%"
                    height="900px"
                    frameBorder="0"
                    src={"https://nadunet.es/apn/compartir/" + this.state.currentCompartir + "/api"}
                  />
                </Row>
              </CardBody>
            </Card>;
        currentTool = 
          <div>
            <Card className="card-plain card-subcategories">
              <CardBody>
                <Nav
                  pills
                  className="nav-pills-primary nav-pills-icons justify-content-center"
                >
                  <NavItem>
                    <NavLink
                      className={
                        this.state.currentCompartir === "android" ? "active" : ""
                      }
                      onClick={() =>
                        this.setState({ currentCompartir: "android" })
                      }
                    >
                      <div>
                        <FontAwesomeIcon icon={['fab', 'android']}  size="3x"/>
                      </div>
                      Android
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={
                        this.state.currentCompartir === "apple" ? "active" : ""
                      }
                      onClick={() =>
                        this.setState({ currentCompartir: "apple" })
                      }
                    >
                      <div>
                        <FontAwesomeIcon icon={['fab', 'apple']}  size="3x"/>
                      </div>
                      Apple
                    </NavLink>
                  </NavItem>
                </Nav>
                {/* <TabContent
                  className="tab-space tab-subcategories"
                  activeTab={this.state.currentApn}
                >
                  <TabPane tabId={this.state.currentApn}>
                    Collaboratively administrate empowered markets via
                    plug-and-play networks. Dynamically procrastinate B2C
                    users after installed base benefits.
                    <br />
                    <br />
                    Dramatically visualize customer directed convergence
                    without revolutionary ROI.
                  </TabPane>
                </TabContent> */}
              </CardBody>
            </Card>
            {iframeToShow}
          </div>;
        break;
      case "baja-lemon":
        currentTool = 
          <Row>
            <Col xs={12}>
              <Card color="default">
                <CardHeader>
                  {/* <h5 className="title" style={{color:"white"}}>Test de velocidad</h5> */}
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col xd={12}>
                      <Card>
                        <CardBody className="form-inline">
                          <Input
                            type="text"
                            placeholder="Escribe el número..."
                            value={this.state.searchQuery}
                            onChange={e => this.setState({ mobile: e.target.value })}
                            onKeyDown={e => {
                              //console.log(e.keyCode);
                              if (e.keyCode == 13) {
                                if (this.checkMobile(this.state.mobile))
                                //Enter is key code 13
                                  this.unsubscribeMobile();
                                // put the login here
                              }
                            }}
                            style={{ marginRight: "10px" }}
                          />
                          <Button
                            color={
                              this.props.mainState.isUnsubscribingMobile
                                ? "default"
                                : "danger"
                            }
                            round
                            icon
                            onClick={this.unsubscribeMobile}
                            disabled={!this.checkMobile(this.state.mobile) || this.props.mainState.isUnsubscribingMobile}

                          >
                            <i
                              className={
                                this.props.mainState.isUnsubscribingMobile
                                  ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin"
                                  : "now-ui-icons design_scissors"
                              }
                            />
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col xs={12}>
              <Card color="default">
                <CardHeader>
                  <span className="title" style={{color:"black", fontWeight: "300", fontSize: "20px"}}>Historial de bajas</span>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col xd={12}>
                      {!this.props.mainState.unsubscribeHistory && (
                        <span>
                          <i className="now-ui-icons arrows-1_refresh-69 spin" />{" "}
                          Cargando historial...
                        </span>
                      )}
                      {this.props.mainState.unsubscribeHistory &&
                        this.props.mainState.unsubscribeHistory.length === 0 && (
                          <span>No hay registros en el historial.</span>
                        )}
                        {this.props.mainState.unsubscribeHistory &&
                          this.props.mainState.unsubscribeHistory.length > 0 && (
                            this.createMobileUnsubscribeHistory()
                          )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>;
        break;
      case "liberar-SIM":
          currentTool = 
            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody className="form-inline">
                    <Input
                      type="text"
                      placeholder="Escribe el número ICC..."
                      value={this.state.iccQuery}
                      onChange={e => this.setState({ iccQuery: e.target.value })}
                      onKeyDown={e => {
                        //console.log(e.keyCode);
                        if (e.keyCode == 13) {
                          if (this.validateICC(this.state.iccQuery))
                          //Enter is key code 13
                            this.freeSIM();
                        }
                      }}
                      style={{ marginRight: "10px" }}
                    />
                    <Button
                      color={
                        this.props.mainState.isFreeingSIM
                          ? "default"
                          : "warning"
                      }
                      round
                      icon
                      onClick={this.freeSIM}
                      disabled={!this.validateICC(this.state.iccQuery) || this.props.mainState.isFreeingSIM}

                    >
                      <i
                        className={
                          this.props.mainState.isFreeingSIM
                            ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin"
                            : "now-ui-icons ui-1_lock-circle-open"
                        }
                      />
                    </Button>
                  </CardBody>
                </Card>
              </Col>
            </Row>;
          break;
      case "ftth-signal":
        currentTool = 
          <Row>
            <Col xs={12}>
              <Form className="form-horizontal" onSubmit={e => { e.preventDefault(); }}>
                <Card>
                  {/* <CardHeader>
                    <CardTitle tag="h4">Type Validation</CardTitle>
                  </CardHeader> */}
                  <CardBody>
                    <Row>
                      <Col xs={12}>
                        <FormGroup>
                            <i
                              className={
                                "search-coverage-icon " + 
                                (this.props.mainState.isSearchingONTs
                                  ? "now-ui-icons arrows-1_refresh-69 spin"
                                  : "now-ui-icons ui-1_zoom-bold")
                              }
                            />
                            <Input
                              type="text"
                              className="search-coverage"
                              placeholder="Escribe SN/descripción/nombre..."
                              value={this.state.searchONTsQuery}
                              // onChange={e => this.handleChange("searchQuery", e)}
                              onChange={this.handleChange}
                              onKeyDown={this.handleKeyDown}
                              // onKeyDown={e => {
                              //   //console.log(e.keyCode);
                              //   if (e.keyCode == 13) {
                              //     console.log("ola k ase?");
                              //     //Enter is key code 13
                              //     // this.searchCustomer();
                              //     // put the login here
                              //   }
                              // }}
                              // style={{ marginRight: "10px" }}
                            />
                            <Button 
                              block 
                              color="primary"
                              disabled={this.props.mainState.isSearchingONTs}
                              onClick={this.searchONTs}
                              leftLabel={this.props.mainState.isSearchingONTs
                                ? "now-ui-icons arrows-1_refresh-69 spin"
                                : "now-ui-icons ui-1_zoom-bold"}>
                                Buscar
                            </Button>
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                  {/* <CardFooter className="text-center">
                    <Button color="primary" onClick={e => this.typeValidate(e)}>
                      Validate Inputs
                    </Button>
                  </CardFooter> */}
                </Card>
              </Form>
            </Col>
            <Col xs={12}>
              {/* <Card>
                <CardHeader>
                  <span>ONTs encontradas</span>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col xd={12}> */}
                      {this.getONTsFound()}
                      {/* {!this.props.mainState.unsubscribeHistory && (
                        <span>
                          <i className="now-ui-icons arrows-1_refresh-69 spin" />{" "}
                          Cargando historial...
                        </span>
                      )}
                      {this.props.mainState.unsubscribeHistory &&
                        this.props.mainState.unsubscribeHistory.length === 0 && (
                          <span>No hay registros en el historial.</span>
                        )}
                        {this.props.mainState.unsubscribeHistory &&
                          this.props.mainState.unsubscribeHistory.length > 0 && (
                            this.createMobileUnsubscribeHistory()
                          )} */}
                    {/* </Col>
                  </Row>
                </CardBody>
              </Card> */}
            </Col>
          </Row>;
        break;
      case "antenna-config":
        currentTool = 
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <textarea value={this.state.configText} onChange={(e) => {
                      // this.processAntennaConfig(e.target.value);
                      this.setState({ configText: e.target.value });
                    }} />
                </CardBody>
              </Card>
            </Col>
            <Col xs={12}>
              <Card>
                <CardBody>
                  {this.processAntennaConfig(this.state.configText)}
                </CardBody>
              </Card>
            </Col>
          </Row>;
        break;
        default:;
    }
    return currentTool;
  }
  processAntennaConfig(config) {
    if (!config) return null;
    let lines = config.split("\n");
    let configElemens = [];
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      let components = line.split("=");
      let key = components[0];
      let value = components[1];
      configElemens[key] = value;
      // let keyElements = key.split(".");
      // let prevElement = [];
      // for (let j = keyElements.length - 1; j >= 0; j--) {
      //   const element = keyElements[j];
      //   if (j === keyElements.length - 1) {
      //     prevElement[element] = value;
      //   } else {
      //     if (j > 0) {
  
      //     }
      //   }
      // }
    }
    return (
      <div>
        <span><b>Device name: </b> {configElemens["resolv.host.1.name"]}</span><br />
        <span><b>Frequency: </b> {configElemens["radio.1.freq"]}</span><br />
        <span><b>Canal width: </b> {configElemens["radio.1.chanbw"]}</span><br />
        <span><b>TX power: </b> {configElemens["radio.1.txpower"]}</span><br />
        <span><b>SSID: </b> {configElemens["wireless.1.ssid"]}</span>
      </div>
    );
    console.log("device name", configElemens["resolv.host.1.name"]);
    console.log("frequency", configElemens["radio.1.freq"]);
    console.log("canal width", configElemens["radio.1.chanbw"]);
    console.log("tx power", configElemens["radio.1.txpower"]);
    console.log("ssid", configElemens["wireless.1.ssid"]);
  }
  isToolSelected() {
    // console.log("this.props.match.params", this.props.match.params);
    return this.props.match.params && "tool" in this.props.match.params;
    if (this.props.match.params) {
      if (Object.keys(this.props.match.params) > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  render() {
    // console.log("######## PARAMS TOOLS ##########");
    // console.log(this.props.match.params);
    let toolsCards = this.createToolsCards();
    let currentTool = this.createCurrentTools();
    let _isToolSelected = this.isToolSelected();
    // console.log("_isToolSelected", _isToolSelected);
    return (
      <div>
        <PanelHeader
          size="sm"
          content={
            <div>
              {/* <h6 style={dashboardOrdersTitleStyle}>Herramientas</h6> */}
            </div>
          }
        />
        <div className="content">
          {this.state.showPopUp && this.createPopUp()}
          {this.state.popUpConfirmation}
          <Row>
            {toolsCards}
            <Col xs={12} md={12}>
              {currentTool}
            </Col>
            {/* {this.createInternetCards()}
            {this.createMobileCards()} */}
            {/* <Col md={8} xs={12}>
              <Card className="card-plain card-subcategories">
                <CardBody>
                  <Nav
                    pills
                    className="nav-pills-primary nav-pills-icons justify-content-center"
                  >
                    <NavItem>
                      <NavLink
                        className={
                          this.state.currentApn === "samsung" ? "active" : ""
                        }
                        onClick={() =>
                          this.setState({ currentApn: "samsung" })
                        }
                      >
                        <div>
                          <FontAwesomeIcon icon={['fab', 'stripe-s']} size="3x"/>
                        </div>
                        Samsung
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={
                          this.state.currentApn === "xiaomi" ? "active" : ""
                        }
                        onClick={() =>
                          this.setState({ currentApn: "xiaomi" })
                        }
                      >
                        <div>
                          <FontAwesomeIcon icon="times" size="4x"/>
                        </div>
                        Xiaomi
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={
                          this.state.currentApn === "huawei" ? "active" : ""
                        }
                        onClick={() =>
                          this.setState({ currentApn: "huawei" })
                        }
                      >
                        <div>
                          <FontAwesomeIcon icon="heading" size="3x"/>
                        </div>
                        Huawei
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={
                          this.state.currentApn === "apple" ? "active" : ""
                        }
                        onClick={() =>
                          this.setState({ currentApn: "apple" })
                        }
                      >
                        <div>
                          <FontAwesomeIcon icon={['fab', 'apple']}  size="3x"/>
                        </div>
                        Apple
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={
                          this.state.currentApn === "otros" ? "active" : ""
                        }
                        onClick={() =>
                          this.setState({ currentApn: "otros" })
                        }
                      >
                        <div>
                          <FontAwesomeIcon icon="mobile-alt" size="3x" />
                        </div>
                        Otros Android
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent
                    className="tab-space tab-subcategories"
                    activeTab={this.state.currentApn}
                  >
                    <TabPane tabId="samsung">
                      Collaboratively administrate empowered markets via
                      plug-and-play networks. Dynamically procrastinate B2C
                      users after installed base benefits.
                      <br />
                      <br />
                      Dramatically visualize customer directed convergence
                      without revolutionary ROI.
                    </TabPane>
                    <TabPane tabId="xiaomi">
                      Efficiently unleash cross-media information without
                      cross-media value. Quickly maximize timely deliverables
                      for real-time schemas.
                      <br />
                      <br />
                      Dramatically maintain clicks-and-mortar solutions without
                      functional solutions.
                    </TabPane>
                    <TabPane tabId="huawei">
                      Completely synergize resource taxing relationships via
                      premier niche markets. Professionally cultivate one-to-one
                      customer service with robust ideas.
                      <br />
                      <br />
                      Dynamically innovate resource-leveling customer service
                      for state of the art customer service.
                    </TabPane>
                    <TabPane tabId="apple">
                      Completely synergize resource taxing relationships via
                      premier niche markets. Professionally cultivate one-to-one
                      customer service with robust ideas.
                      <br />
                      <br />
                      Dynamically innovate resource-leveling customer service
                      for state of the art customer service.
                    </TabPane>
                    <TabPane tabId="otros">
                      Completely synergize resource taxing relationships via
                      premier niche markets. Professionally cultivate one-to-one
                      customer service with robust ideas.
                      <br />
                      <br />
                      Dynamically innovate resource-leveling customer service
                      for state of the art customer service.
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col> */}
          </Row>
        </div>
      </div>
    );
  }
}

export default Tools;



// WEBPACK FOOTER //
// ./src/views/Tools/Tools.jsx